// base rc-mentions .6.2
import Mentions from './src/Mentions';
import Option from './src/Option';
Mentions.Option = Option;
export { Option };
export default Mentions;
